'use client';

import { useEffect, useState } from 'react';
import { getWishlist, WISHLIST_CHANGED } from '@/lib/wishlist';
import { openWishlistDrawer } from '@/lib/wishlist-drawer';

export function HeaderWishlist() {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    function refresh() { setCount(getWishlist().length); }
    refresh();
    window.addEventListener(WISHLIST_CHANGED, refresh);
    return () => window.removeEventListener(WISHLIST_CHANGED, refresh);
  }, []);

  // Anchor with onClick — plain click opens the drawer, but cmd/ctrl/middle-click
  // fall through to /wishlist so power users can still open the full page in a tab.
  return (
    <a
      href="/wishlist"
      aria-label="Favorites"
      onClick={(e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
        e.preventDefault();
        openWishlistDrawer();
      }}
      className="relative hover:text-ink hidden sm:inline-flex"
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 21s-7-4.5-9.5-9C1.2 9.4 2.4 6.5 5 5.4c2-.8 4.2 0 5.5 1.6l.5.6.5-.6c1.3-1.6 3.5-2.4 5.5-1.6 2.6 1.1 3.8 4 2.5 6.6C19 16.5 12 21 12 21z" />
      </svg>
      {count !== null && count > 0 && (
        <span
          className="absolute -top-1.5 -right-1.5 bg-rose text-bone text-[9px] font-bold rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center font-numerals tabular-nums leading-none"
          aria-label={`${count} ${count === 1 ? 'item' : 'items'} saved`}
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </a>
  );
}
